import { FETCH_SETTINGS_REQUEST_ASYNC as FETCH_GROUP_SETTINGS_REQUEST_ASYNC } from 'containers/GroupSettings/Wizard/constants'
import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  GET_ANNOUNCEMENTS_LOGO_ASYNC,
  SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC,
  UPDATE_ANNOUNCEMENTS_LOGO,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_ANNOUNCEMENTS_LOGO:
        return {
          ...state,
          data: {
            ...state.data,
            notificationsLogoTemplate: action.payload.data,
          },
        }
      case COMPANY_FILTER_CHANGE:
      case GET_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE:
      case SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case GET_ANNOUNCEMENTS_LOGO_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case FETCH_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data?.endUserLogo,
          loader: false,
        }
      case GET_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL:
      case SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL:
      case SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.SUCCESS:
        return { ...state, loader: false, error: null }
      case GET_ANNOUNCEMENTS_LOGO_ASYNC.ERROR:
      case SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      default:
        return state
    }
  }
}
